module.exports = require("./cs-CZ.js");